module.exports = __webpack_public_path__ + "static/unity_img_4-a63e92e6086d0ee37d2d9dd652edab76.png";